function record(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function reportRows(value, optional = false) {
    if (optional && value === undefined) return [];
    if (!Array.isArray(value) || !value.every(record)) throw new Error('Struktur hasil laporan belum lengkap.');
    return value;
}

export function validateAdminReport(value, individual = false) {
    if (!record(value)) throw new Error('Hasil laporan belum tersedia.');
    reportRows(value.dataMapel).forEach(mapel => {
        if (individual) {
            if (!record(mapel.kategori)) throw new Error('Kategori laporan belum lengkap.');
        } else {
            reportRows(mapel.kategories);
        }
    });
    reportRows(value.dataIndikator).forEach(mapel => reportRows(mapel.indikator));
    const nonAcademic = value.dataNonAkademik === undefined ? {} : value.dataNonAkademik;
    if (!record(nonAcademic)) throw new Error('Hasil nonakademik belum lengkap.');
    const SK = reportRows(nonAcademic.SK, true);
    const SLB = reportRows(nonAcademic.SLB, true);
    if (!individual) reportRows(value.indekSosial).forEach(item => reportRows(item.kategori));
    return {...value, dataNonAkademik: {...nonAcademic, SK, SLB}};
}
